import { ITicketStatusType } from "models/Ticket";
import { IUser, UserProfileTypes } from "models/User";
import { inputsDisableToPhaseApprovalForLoss, labelMinimalReadOnly, labelReadOnly } from "pages/Pipefy/config";
import { PhasesProtocols, PipefyFieldIdsEnum } from "pages/Pipefy/enum";
import { CardProps, CurrentPhaseMovedToPhasesProps, FieldsCardProps, FieldsCurrentPhaseProps, PhasesHistoryFieldsProps, PhasesHistoryProps } from "pages/Pipefy/interface";
import { RemoveAccent } from "utils/String";

const pipefyBucketUrl = "https://app-storage-service.pipefy.com/v1/signed/";
const presignedBucketUrl = "https://pipefy-prd-us-east-1.s3.amazonaws.com/";
const pipefyBucketStorageUrl = "https://app.pipefy.com/storage/v1/signed/";

export function urlReplace(url: string) {
    return url
        .trim()
        .replace(pipefyBucketUrl, "")
        .replace(presignedBucketUrl, "")
        .replace(pipefyBucketStorageUrl, "")
        .trim();
};

export function fixUrls(files: string[]): string[] {
    return files.map((c) => {
        const url = urlReplace(c);
        return url.indexOf("?") > -1 ? url.substr(0, url.indexOf("?")) : url;
    });
}

export function orderHistoryProtocol(array: PhasesHistoryProps[]) {
    array = array.filter(x => x.firstTimeIn !== null &&
        x.lastTimeIn !== null && x.duration !== null
    );

    const lastItem = array.find((x: PhasesHistoryProps) => x.lastTimeOut === null) ?? {};
    const allItensWithoutNull = array.filter((x: PhasesHistoryProps) => x.lastTimeOut !== null);
    const reorderedItems: PhasesHistoryProps[] = allItensWithoutNull.sort(function (a: any, b: any) {
        let x: any = new Date(a.lastTimeOut),
            y: any = new Date(b.lastTimeOut);

        return x - y;
    });

    reorderedItems.push(lastItem);

    return reorderedItems;
};

export function historyfieldsFilter(fields: any[], phaseName: string, user?: IUser) {
  const valueToCheck: keyof typeof UserProfileTypes = "COSMETOVIGILANCE_QUALITY";
  const isDifferentCosmetovigilanceRole = user?.profileType &&
     !user?.profileType.includes(valueToCheck) &&
     phaseName === PhasesProtocols.REGISTRO_EVENTOS_ADVERSOS;
  
  if (isDifferentCosmetovigilanceRole) return [];

  return fields;

}

export function cleanStr(str: string, upperCase?: boolean) {
    if (!str) return "";

    let cleaned = str.replace(/["[\]]/g, "");

    if (!upperCase) return cleaned;
    cleaned = cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
    return cleaned;
}

export function getStatusType(phaseName: string) {
    switch (phaseName.toUpperCase()) {
        case "NOVO":
            return ITicketStatusType.QUEUED;
        case "PROTOCOLO CONCLUÍDO":
        case "PROTOCOLO CANCELADO":
        case "AUTOATEDIMENTO REALIZADO":
            return ITicketStatusType.DONE;
        default:
            return ITicketStatusType.IN_ATTENDANCE;
    }
}

export function isLabelMinimalReadOnly(label: string) {
    return labelMinimalReadOnly.includes(label);
};

export function isInputDisableToPhaseApprovalForLoss(id: string) {
    return inputsDisableToPhaseApprovalForLoss.includes(id);
};

export function isManualDevolutionEnterprise(code: number | undefined) {
    const manualDevolutionEnterpriseCodes = [98, 99];
    return code !== undefined && manualDevolutionEnterpriseCodes.includes(code);
};

export function isLabelReadOnly(label: string) {
    return labelReadOnly.includes(label);
};

export function getDonePhasesOnly(phases: CurrentPhaseMovedToPhasesProps[]) {
    const donePhases: string[] = ["PROTOCOLO CONCLUÍDO", "PROTOCOLO CANCELADO"];
    return phases.filter(phase => donePhases.includes(phase.name.toUpperCase()));
}

export const getApprovalFieldId = (currentPhase: string): PipefyFieldIdsEnum | undefined => {
    switch (currentPhase) {
        case PhasesProtocols.AVALIACAO_GERENCIA_COMERCIAL:
            return PipefyFieldIdsEnum.APROVADOR_GERENCIA_COMERCIAL;
        case PhasesProtocols.AVALIACAO_DIRETORIA_COMERCIAL:
            return PipefyFieldIdsEnum.APROVADOR_DIRETORIA_COMERCIAL;
        default:
            return undefined;
    }
};

export function processResponsibleGroup(result: any) {

    const fieldCurrentPhase = result.data.card.current_phase.fields.find(
        (item: any) => item.label.toUpperCase() === "GRUPO RESPONSÁVEL"
    );

    if (fieldCurrentPhase) {
        let getResponsibleGroupForm = fieldCurrentPhase?.options[0];

        if (fieldCurrentPhase?.options.length > 1) {
            // buscar o field pelo id encontrado acima
            const field = result.data.card.fields.find(
                (item: any) => item.field.id === fieldCurrentPhase?.id
            );

            // pegar o valor do grupo responsável
            getResponsibleGroupForm = field?.value;
        }

        if (getResponsibleGroupForm) {
            RemoveAccent(getResponsibleGroupForm);
        }
    }
}

export const hideExchangeLetterPdfHistory = (data: CardProps) => {
    data.phases_history.forEach((history: PhasesHistoryProps) => {
        const fieldPdf = historyPhaseFields(history, 'pdf_carta_de_troca');

        const valuePdf = cleanStr(data.fields.find((item: FieldsCardProps) =>
            item.field.id === fieldPdf?.id)?.value || ""
        );

        if (!valuePdf) {
            const indexOf = history.phase?.fields?.map(
                (item: PhasesHistoryFieldsProps) => item.id
            ).indexOf('pdf_carta_de_troca') || 0;

            if (indexOf > -1) history.phase?.fields?.splice(indexOf, 1);
        }
    });
};

const historyPhaseFields = (history: PhasesHistoryProps, id: string) => {
    return history.phase?.fields?.find(
        (item: PhasesHistoryFieldsProps) => item.id === id);
};

export const getFieldValueFromHistory = (data: CardProps, fieldId: PipefyFieldIdsEnum): string => {
    let value = "";

    data.phases_history.forEach((history: PhasesHistoryProps) => {
        const field = historyPhaseFields(history, fieldId);

        const fieldValue = cleanStr(data.fields.find((item: FieldsCardProps) =>
            item.field.id === field?.id)?.value || ""
        );

        if (fieldValue)
            value = fieldValue;
    });

    return value;
};